/**
 * @generated SignedSource<<c2c2d3b2ee1cd1f5d46715b6c93c3ddc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type JiraVersionDetailsCollapsedUi = "DESCRIPTION" | "ISSUES" | "ISSUE_ASSOCIATED_DESIGNS" | "PROGRESS_CARD" | "RELATED_WORK" | "RICH_TEXT_SECTION" | "RIGHT_SIDEBAR" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type ui_softwareReleasesVersionDetail_VersionDetailInner_jiraVersion$data = {
  readonly allIssues: {
    readonly totalCount: number | null | undefined;
  } | null | undefined;
  readonly canAddAndRemoveIssues: boolean | null | undefined;
  readonly collapsedUis: ReadonlyArray<JiraVersionDetailsCollapsedUi | null | undefined> | null | undefined;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"async_softwareReleasesApprovers_Approvers" | "async_softwareReleasesLaunchCard_LaunchCard" | "async_softwareReleasesVersionRichTextSection_AsyncVersionRichTextSection" | "header_softwareReleasesVersionDetail" | "rightSidebar_softwareReleasesVersionDetail" | "ui_softwareReleasesAddIssuesToVersion_AddIssuesToVersion" | "ui_softwareReleasesVersionDetailIssueList_IssueListWithHeaderWithErrorBoundary_jiraVersion">;
  readonly " $fragmentType": "ui_softwareReleasesVersionDetail_VersionDetailInner_jiraVersion";
};
export type ui_softwareReleasesVersionDetail_VersionDetailInner_jiraVersion$key = {
  readonly " $data"?: ui_softwareReleasesVersionDetail_VersionDetailInner_jiraVersion$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_softwareReleasesVersionDetail_VersionDetailInner_jiraVersion">;
};

import versionDetailPageRefetchQuery_graphql from './versionDetailPageRefetchQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "filters"
    },
    {
      "kind": "RootArgument",
      "name": "isDevopsFeatureDisabledInFedRamp"
    },
    {
      "kind": "RootArgument",
      "name": "isIssueSummarisedDeploymentsMigratedToAgs"
    },
    {
      "kind": "RootArgument",
      "name": "shouldIncludeDevOpsFieldsViaAgs"
    },
    {
      "kind": "RootArgument",
      "name": "sortBy"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "fragmentPathInResult": [
        "node"
      ],
      "operation": versionDetailPageRefetchQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "ui_softwareReleasesVersionDetail_VersionDetailInner_jiraVersion",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "canAddAndRemoveIssues"
    },
    {
      "kind": "ScalarField",
      "name": "collapsedUis"
    },
    {
      "alias": "allIssues",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": "ALL"
        }
      ],
      "concreteType": "JiraIssueConnection",
      "kind": "LinkedField",
      "name": "issues",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "totalCount"
        }
      ],
      "storageKey": "issues(filter:\"ALL\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "async_softwareReleasesLaunchCard_LaunchCard"
    },
    {
      "kind": "FragmentSpread",
      "name": "header_softwareReleasesVersionDetail"
    },
    {
      "kind": "FragmentSpread",
      "name": "ui_softwareReleasesAddIssuesToVersion_AddIssuesToVersion"
    },
    {
      "kind": "FragmentSpread",
      "name": "ui_softwareReleasesVersionDetailIssueList_IssueListWithHeaderWithErrorBoundary_jiraVersion"
    },
    {
      "kind": "FragmentSpread",
      "name": "async_softwareReleasesApprovers_Approvers"
    },
    {
      "kind": "FragmentSpread",
      "name": "rightSidebar_softwareReleasesVersionDetail"
    },
    {
      "kind": "FragmentSpread",
      "name": "async_softwareReleasesVersionRichTextSection_AsyncVersionRichTextSection"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "18efada2730a05c083b285addf6cb338";

export default node;
